import { Action } from '@ngrx/store';

export enum HomeActionTypes {
  StartLoadHomeInformation = '[Home] Start Load Home Information',
  HomeInformationLoaded = '[Home] Home Information Loaded',
  FetchError = '[Home] Fetch Error',
}

export class StartLoadHomeInformation implements Action {
  readonly type = HomeActionTypes.StartLoadHomeInformation;

  constructor(public page: string = 'home') {}
}

export class FetchError implements Action {
  readonly type = HomeActionTypes.FetchError;

  constructor(public payload: any[], public actionType?: HomeActionTypes) {}
}

export type HomeActions =
  | StartLoadHomeInformation
  | FetchError;
